import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const contract = {
  state: {
    regularContract: false,
    company: {
      name: "",
      cvr: "",
      address: "",
      phone: "",
    },
    drivingLicense: {
      number: "",
      expirationDate: "",
      a: false,
      b: false,
      c: false,
      d: false,
      e: false,
      be: false,
      ce: false,
      de: false,
    },
    employee: {
      name: "",
      address: "",
      cpr: "",
      municipality: "",
      phone: "",
      registrationNumber: "",
      bankAccount: "",
    },
    employmentDetails: {
      location: "",
      startingDate: "",
    },
    healthControl: {
      isEnabled: false,
    },
    holiday: {
      closed: false,
      granted: false,
      closedPeriod: "",
      grantedPeriod: "",
    },
    jobCategories: {
      driver: false,
      driverExtended: false,
      movingServices: false,
      exportDriver: false,
      renovation: false,
      other: false,
      otherDescription: "",
    },
    locale: {
      formLocale: "da-DK",
      contractLocale: "da-DK",
    },
    pension: {
      optionOne: false,
      optionTwo: false,
      optionThree: false,
      optionTwoStartingDate: "",
      optionThreeFinalDate: "",
      companyContribution: "",
      employeeContribution: "",
    },
    qualifications: {
      vet: false,
      driverEuro: false,
      stacker: false,
      forklift: false,
      crane: false,
      other: false,
      adr: false,
      vetDate: "",
      driverEuroExpirationDate: "",
      adrExpirationDate: "",
      vubExpirationDate: "",
      otherDescription: "",
    },
    salary: {
      amount: "",
    },
    salaryPeriod: {
      payday: "",
    },
    sickness: {
      reportNow: false,
      reportThreeDays: false,
    },
    socialSecurityInstitutions: {
      workInsuranceCompany: '',
      otherSystems: false,
      otherSystemsDescription: ""
    },
    specialTerms: {
      sickness: false,
      sicknessText: "",
      alcohol: false,
      alcoholText: "",
      breaks: false,
      breaksDuration: "",
      gps: false,
      gpsText: "",
      speeding: false,
      speedingText: "",
      other: false,
      otherTerms: [],
    },
    tachographLicense: {
      hasLicense: false,
      number: "",
      expirationDate: "",
    },
    workingConditions: {
      shift: false,
      inconvenient: false,
    },
  },
  mutations: {
    updateCompany(state, company) {
      state.company = company;
    },
    updateContractLocale(state, locale) {
      state.locale.contractLocale = locale;
    },
    updateDrivingLicense(state, license) {
      state.drivingLicense = license;
    },
    updateEmployee(state, employee) {
      state.employee = employee;
    },
    updateEmploymentDetails(state, details) {
      state.employmentDetails = details;
    },
    updateFormLocale(state, locale) {
      state.locale.formLocale = locale;
    },
    updateHealthControl(state, healthControl) {
      state.healthControl = healthControl;
    },
    updateHoliday(state, holiday) {
      state.holiday = holiday;
    },
    updateJobCategories(state, categories) {
      state.jobCategories = categories;
    },
    updatePension(state, pension) {
      state.pension = pension;
    },
    updateQualifications(state, qualifications) {
      state.qualifications = qualifications;
    },
    updateSalary(state, salary) {
      state.salary = salary;
    },
    updateSalaryPeriod(state, period) {
      state.salaryPeriod = period;
    },
    updateSickness(state, sickness) {
      state.sickness = sickness;
    },
    updateSocialSecurityInstitutions(state, socialSecurityInstitutions) {
      state.socialSecurityInstitutions = socialSecurityInstitutions;
    },
    updateSpecialTerms(state, terms) {
      state.specialTerms = terms;
    },
    updateTachographLicense(state, license) {
      state.tachographLicense = license;
    },
    updateWorkingConditions(state, coditions) {
      state.workingConditions = coditions;
    },
    updateWorkingHoursInputA(state, days) {
      state.workingHours.A.days = days;
    },
    updateWorkingHoursInputB(state, days) {
      state.workingHours.B.days = days;
    },
    updateWorkingHoursInputC(state, days) {
      state.workingHours.C.days = days;
    },
    updateWorkingHoursOptions(state, options) {
      state.workingHours.options = options;
    },
  },
};

export const store = new Vuex.Store({
  modules: {
    contract: contract,
  },
});
